import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "flex items-center justify-between w-full" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "p-4" }
const _hoisted_5 = { class: "text-sm font-bold" }
const _hoisted_6 = {
  key: 0,
  class: "px-2 py-1 mr-1 text-xs italic bg-neutral-200 text-neutral-600 rounded-2xl"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 text-[0.625rem] mb-1" }, "Case Number", -1)
const _hoisted_8 = { class: "p-2 font-bold text-xs rounded-[6px] bg-primary-400 text-primary-600 leading-[18px]" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 text-[0.625rem]" }, "To be Done By", -1)
const _hoisted_11 = { class: "px-2 py-1 mt-1 mr-1 text-xs italic bg-neutral-200 text-neutral-600 rounded-2xl" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 text-[0.625rem]" }, "Done On", -1)
const _hoisted_14 = { class: "flex flex-wrap items-center" }
const _hoisted_15 = { class: "px-2 py-1 mt-1 mr-1 text-xs italic bg-neutral-200 text-neutral-600 rounded-2xl" }

import { ref, type PropType, computed } from "vue";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import DateDetail from "@/components/partials/DateDetail.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import { TrashIcon } from "@heroicons/vue/24/solid";
import { useRouter, useRoute } from "vue-router";
import { InterventionItems } from "@/interfaces/Cases/Interevention";
import InterventionService from "@/classes/Cases/InterventionService";
import { errorResponse } from "@/helpers/errorMessage";
import { InterventionType } from "@/views/enums/InterventionType";
import ThreeDotsIcon from "@/components/icons/threeDotsIcon.vue";
import PencilIcon from "@/components/icons/pencilIcon.vue";
import pickBy from "lodash/pickBy";
import { useNetworkStore } from "@/store/network";


export default /*#__PURE__*/_defineComponent({
  __name: 'InterventionCard',
  props: {
	typeTwo: {
		type: Boolean,
		default: false,
	},
	interventionType: {
		type: String,
		default: null,
	},
	intervention: {
		type: String,
		default: null,
	},
	caseNumber: {
		type: String,
		default: null,
	},
	doneBy: {
		type: String,
		default: null,
	},
	doneOn: {
		type: String,
		default: null,
	},
	status: {
		type: String,
		default: "Scheduled", // Scheduled | Past Due | Done
	},
	item: {
		type: Object as PropType<InterventionItems>,
		required: true,
	},
},
  emits: ['update:refresh'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const route = useRoute();
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const deleteSuccessMessage = ref<string>("Selected record has been successfully deleted.");
const restoreSuccessMessage = ref<string>("Selected record has been successfully restored.");

const props = __props;

const emit = __emit;

const statusIsNotDone = computed<boolean>(() => props.status !== 'Done');
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const showRestoreConfirmation = ref<boolean>(false);
const showRestoreSuccess = ref<boolean>(false);
const errors = ref<object | null>(null);

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
const offlineParams = ref<string>(route.query.offline);
const selectedItemId = computed(() => props.item.id ?? props.item?.offlineData?.offline_id);

const editRoute = (item:any): string => {

	let url = `/patient/${item.patient_id}/intervention/${item.intervention_type}/edit/${item.id}`;

    if(caseId?.value){
        url = `/patient/${item.patient_id}/cases/${item.cases_id}/intervention/${item.intervention_type}/edit/${item.id}`;
    } 
	
	router.push(url);
}


const remove = (): void => {
	showConfirmation.value = false;
	InterventionService.delete(
		patientId.value,
		caseId.value,
		selectedItemId.value,
		pickBy({ isOfflineData: offlineParams.value ? true : false }),
		isNetworkAvailable.value
	)
	.then((response: object) => {
		showSuccess.value = true;
		deleteSuccessMessage.value = response.data.message;
	})
	.catch((error: object) => {
		console.log(error)
		errors.value = errorResponse(error.response?.data?.errors);
	});
};

const restore = (): void => {
	showRestoreConfirmation.value = false;
	InterventionService.restore(patientId.value, caseId.value, props.item.id, {})
		.then((response: object) => {
			showRestoreSuccess.value = true;
			restoreSuccessMessage.value = response.data.message;
		})
		.catch((error: object) => {
			errors.value = errorResponse(error.response?.data?.errors);
		});
};

const redirectSuccess = (): void => {
	showSuccess.value = false;
    emit('update:refresh');
};

const redirectRestoreSuccess = (): void => {
	showSuccess.value = false;
	window.location.href = caseId.value
		? `/patient/${patientId.value}/cases/${caseId.value}/interventions`
		: `/intervention/${patientId.value}/view`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    href: _ctx.routeLink,
    class: "flex flex-col md:p-6 p-4 space-y-2 bg-white border border-gray-200 rounded-2xl"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DateDetail, {
        customColor: __props.status == 'Scheduled' ? '#16a34a' : __props.status == 'Past Due' ? '#dc2626' : '#0071fa',
        textColor: 
					__props.status == 'Scheduled'
						? 'text-green-600'
						: __props.status == 'Past Due'
						? 'text-red-600'
						: 'text-primary-600'
				,
        date: __props.item.scheduled_date
      }, null, 8, ["customColor", "textColor", "date"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass(["text-xs font-semibold px-2 py-1 leading-[18px] rounded-lg text-white mr-2", 
						__props.status == 'Scheduled' ? 'bg-green-600' : __props.status == 'Past Due' ? 'bg-red-600' : 'bg-primary-600'
					])
        }, _toDisplayString(__props.status), 3),
        _createVNode(_unref(Menu), {
          class: "relative flex",
          as: "div"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MenuButton), null, {
              default: _withCtx(() => [
                _createVNode(ThreeDotsIcon, { class: "object-contain w-5 h-5 cursor-pointer" })
              ]),
              _: 1
            }),
            _createVNode(_Transition, {
              "enter-active-class": "transition duration-100 ease-out",
              "enter-from-class": "transform scale-95 opacity-0",
              "enter-to-class": "transform scale-100 opacity-100",
              "leave-active-class": "transition duration-75 ease-in",
              "leave-from-class": "transform scale-100 opacity-100",
              "leave-to-class": "transform scale-95 opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(MenuItems), { class: "absolute right-0 z-10 mt-7 min-w-[180px] origin-top-right rounded bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      (_unref(route).query.tab !== 'archived')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_unref(MenuItem), null, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (editRoute(__props.item))),
                                  class: "flex items-center mb-2 text-sm cursor-pointer"
                                }, [
                                  (statusIsNotDone.value)
                                    ? (_openBlock(), _createBlock(PencilIcon, {
                                        key: 0,
                                        class: "w-6 h-6 object-contain mr-1.5 invert"
                                      }))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(__props.status === 'Done' ? "View" : "Edit"), 1)
                                ])
                              ]),
                              _: 1
                            }),
                            (statusIsNotDone.value)
                              ? (_openBlock(), _createBlock(_unref(MenuItem), { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", {
                                      class: "flex items-center text-sm cursor-pointer",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (showConfirmation.value = true))
                                    }, [
                                      _createVNode(_unref(TrashIcon), { class: "w-6 h-6 mr-1.5" }),
                                      _createTextVNode(" Remove ")
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createBlock(_unref(MenuItem), { key: 1 }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", {
                                class: "flex items-center text-sm cursor-pointer",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (showRestoreConfirmation.value = true))
                              }, [
                                _createVNode(_unref(TrashIcon), { class: "w-6 h-6 mr-1.5" }),
                                _createTextVNode(" Restore ")
                              ])
                            ]),
                            _: 1
                          }))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("p", _hoisted_5, _toDisplayString(__props.interventionType || "-"), 1),
    _createElementVNode("div", null, [
      (__props.intervention)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.intervention), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _hoisted_7,
      _createElementVNode("span", _hoisted_8, _toDisplayString(__props.caseNumber || "-"), 1)
    ]),
    (!__props.typeTwo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(__props.doneBy || "-"), 1)
        ]))
      : _createCommentVNode("", true),
    (!__props.typeTwo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(__props.doneOn || "-"), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (errors.value?.message)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass(["text-[10px] mt-1", errors.value?.message ? 'text-red-600' : 'text-gray-800']),
            id: "email-error"
          }, _toDisplayString(errors.value?.message), 3))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ConfirmationModal, {
      typeTwo: true,
      show: showConfirmation.value,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (showConfirmation.value = false)),
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (remove())),
      "cancel-text": "Cancel",
      "action-text": "Confirm",
      title: "Delete Record?",
      content: "Are you sure you wish to delete this record?"
    }, null, 8, ["show"]),
    _createVNode(SuccessModal, {
      show: showSuccess.value,
      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (redirectSuccess())),
      "action-text": "Close",
      title: "Record Deleted!",
      content: deleteSuccessMessage.value
    }, null, 8, ["show", "content"]),
    _createVNode(ConfirmationModal, {
      typeTwo: true,
      show: showRestoreConfirmation.value,
      onCancel: _cache[6] || (_cache[6] = ($event: any) => (showRestoreConfirmation.value = false)),
      onConfirm: _cache[7] || (_cache[7] = ($event: any) => (restore())),
      "cancel-text": "Cancel",
      "action-text": "Confirm",
      title: "Restore Record?",
      content: "Are you sure you wish to restore this record?"
    }, null, 8, ["show"]),
    _createVNode(SuccessModal, {
      show: showRestoreSuccess.value,
      onConfirm: _cache[8] || (_cache[8] = ($event: any) => (redirectRestoreSuccess())),
      "action-text": "Close",
      title: "Record Restored!",
      content: restoreSuccessMessage.value
    }, null, 8, ["show", "content"])
  ], 8, _hoisted_1))
}
}

})